/**
 * Labstep
 *
 * @module core/DataGrid/ColumnHeader/EntityImport/DateFormat
 * @desc Dropdown to switch metadata type
 */

import { useGridEntityImportServiceFromContext } from 'labstep-web/contexts/grid/hook';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { DropdownPortal as Dropdown } from 'labstep-web/core/Dropdown/Portal';
import type React from 'react';
import type { DataGridColumnHeaderEntityImportDateFormatProps } from './types';
import { getOptions } from './utils';

export const DataGridColumnHeaderEntityImportDateFormat: React.FC<
  DataGridColumnHeaderEntityImportDateFormatProps
> = ({ colDef }) => {
  const gridEntityImportService =
    useGridEntityImportServiceFromContext();
  if (!gridEntityImportService) {
    return null;
  }

  return (
    <Dropdown
      trigger={<div>{colDef.entity_import?.date_format}</div>}
      closeOnChange
    >
      {getOptions(colDef).map((option) => (
        <ActionComponent
          key={option}
          type="option"
          text={option}
          onClick={(): void =>
            gridEntityImportService.setColDefEntityImportParameter(
              colDef.colId,
              {
                date_format: option,
              },
            )
          }
        />
      ))}
    </Dropdown>
  );
};
